import { SERVICES_RESP } from "../../configurations";
import { I_TRADE_ACTION } from "../../constants/i-trade";
import { Converter } from "../../helpers/functions";
import { stockServices } from "../../services/trading-services/stock.services";
import {
  ACTION_TYPE,
  DEVICE_TYPE,
  MDSMACHINES_NUMER,
} from "../../constants/w-socket";
import { utilsFunction } from "../../helpers/functions";
import { getSafeStorage, saveSafeStorage, getInitState } from "../../helpers/global";
import { STORAGE_KEY as storageKey } from "../../constants/storage.key";
import moment from "moment";
import { dispatch } from "rxjs/internal/observable/pairs";
import { iTradeEnv } from "@/configurations/app-configs/iTrade.env";
import { store } from "@/configurations";
import { appConfigConstants } from "@/configurations/app-configs/app.config.constants";
import { ENDPOINT_REQUEST } from "@/configurations";
import { userServices } from "@/services/user-services";
import { WS_LANG_KEY } from "@/constants/app";
import { openConnection } from "@/helpers/functions/websocket";

var CryptoJS = require("crypto-js");

const initStateFunc = getInitState({
  EIFLogin: true,
});
const LOGIN_ITEM = initStateFunc("TTLLogin");

export const stockActions = {
  getInstrumentDetailAction,
  getSpreadTableAction,
  getGoodTillDateAction,
  changeMarketAction,
  enquireInstrumentInfoAction,
  getNewsAction,
  setMarketStockAction,
  setNoChangeMarketStockAction,
  getFinancialAction,
  getWSStockAction,
  loginMDSAction,
  logoutMDSAction,
  getDetailPriceInfoAction,
  getWarrantDetailPriceInfoAction,
  getTradeDistributionAction,
  getCompanyInfoAction,
  getShareChangeAction,
  getDividendRecordAction,
  getHistoricalData,
  getTopRankAction,
  getDetailIndustryRankAction,
  getwarrantsAction,
  getFinancialsDataAction,
  setPlaceOrderParamsAction,
  getIndexDataAction,
  getAggregateOrderBookAction,
  getClosingPriceAction,
  getStatisticsAction,
  getBestBidBestAskAction,
  getOptionsAction,
  getSeriesProductAction,
  getBrokerQueueAction,
  getTradeLogAction,
  getTradeTickerAction,
  getSecurityDefintionAction,
  getGreyAggregateOrderBookAction,
  getGreyBrokerQueueAction,
  getGreyTradeLogAction,
  getGreyTradeTickerAction,
  getGreySecurityDefintionAction,
  getGreyStatisticsAction
};

function getInstrumentDetailAction(params, callback) {
  return (dispatch) => {
    return stockServices.getInstrumentDetailService(params, (res) => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          let name = "";
          if (params.language === "en_US") {
            name = res.result.instrumentName;
          } else {
            name = res.result.instrumentChineseName;
          }
          dispatch({
            type: I_TRADE_ACTION.GET_INSTRUMENT_INFO,
            instrumentInfo: res.result,
          });
          if (!params.no_need_redux) {
            dispatch({
              type: I_TRADE_ACTION.SET_MARKET_STOCK,
              stockCode: res.result.instrumentID,
              marketID: res.result.marketID,
              stockName: name,
            });
          }
        } else {
          if (!params.no_need_redux) {
            dispatch({
              type: I_TRADE_ACTION.SET_MARKET_STOCK,
              stockCode: res.result.instrumentID,
              marketID: res.result.marketID,
              stockName: name,
            });
          }
        }
      }
      callback(res);
    });
  };
}

function getSpreadTableAction(params, callback) {
  return () => {
    return stockServices.getSpreadTableService(params, (res) => {
      callback(res);
    });
  };
}

function getGoodTillDateAction(market = "") {
  const params = {};
  return (dispatch) => {
    return stockServices.getGoodTillDateService(params, (res) => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          const { tradeDateInfoList } = res.result;
          dispatch({
            type: I_TRADE_ACTION.SET_TRADE_DATE_INFO,
            tradeDateInfoList,
          });
          for (let i = 0; i < tradeDateInfoList.length; i++) {
            const tmp = tradeDateInfoList[i];
            if (tmp.marketID === market) {
              const goodTillDates = tmp.tradeDateList.reduce((acc, date) => {
                acc.push({
                  label: date.tradeDate,
                  value: date.tradeDate,
                });
                return acc;
              }, []);
              dispatch({
                type: I_TRADE_ACTION.SET_GOOD_TILL_DATE,
                goodTillDates,
              });
            }
          }
        }
      }
    });
  };
}

function changeMarketAction(market, tradeDateInfoList, tradeConfig) {
  return (dispatch) => {
    dispatch({
      type: I_TRADE_ACTION.SET_CURRENT_MARKET,
      currentMarket: market,
    });
    let marketMap = Object.keys(tradeConfig).reduce((prev, key) => {
      const support = tradeConfig[key].support;
      return Object.assign(prev, support);
    }, {});

    const orderTypeList = marketMap[market].split(",");
    const orderTypes = orderTypeList.reduce((acc, type) => {
      acc.push({
        label: `order_type_${type.toLowerCase()}`,
        value: type,
      });
      return acc;
    }, []);
    dispatch({
      type: I_TRADE_ACTION.SET_ORDER_TYPE,
      orderTypes: orderTypes,
    });
    for (let i = 0; i < tradeDateInfoList.length; i++) {
      const tmp = tradeDateInfoList[i];
      if (tmp.marketID === market) {
        const goodTillDates = tmp.tradeDateList.reduce((acc, date) => {
          acc.push({
            label: date.tradeDate,
            value: date.tradeDate,
          });
          return acc;
        }, []);
        dispatch({
          type: I_TRADE_ACTION.SET_GOOD_TILL_DATE,
          goodTillDates: goodTillDates,
        });
      }
    }
  };
}

function enquireInstrumentInfoAction(p, callback = () => { }) {
  let stockCode = p.instrumentID;
  const stockCodeIndex = p.instrumentID.split('').findIndex(i => i !== '0');
  if (stockCodeIndex > -1) {
    stockCode = stockCode.substr(stockCodeIndex);
  }
  const { mdsToken } = store.getState().trade
  const params = {
    subscribe: null,
    msgTypes: [ACTION_TYPE.DETAIL_PRICE_INFO],
    symbols: [{ exchangeID: Converter.mappingWebSocketMarket(p.exchangeID), key: stockCode }],
    sessID: mdsToken
  }
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.SNAPSHOT, params, callback);
}

function getNewsAction(p, callback = () => { }) {
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.OTHERS, p, callback);
}

function getFinancialAction(p, callback = () => { }, handleErr = () => { }) {
  let params = Object.assign({}, p, {
    subscribe: null,
    msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA
  })
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.OTHERS, params, callback, handleErr);
}

function getDetailPriceInfoAction(p, callback = () => { }, handleErr = () => { }) {
  return dispatch => {
    let params = Object.assign({}, p, {
      subscribe: null,
      msgTypes: [ACTION_TYPE.DETAIL_PRICE_LV2]
    })
    return openConnection(
      ENDPOINT_REQUEST.wsSTOCK.SNAPSHOT,
      params,
      (res) => {
        if (res.msgType === ACTION_TYPE.DETAIL_PRICE_INFO) {
          callback(res);
        } else {
          handleErr(res);
        }
      },
      handleErr
    );
  }
}

function getWarrantDetailPriceInfoAction(p, callback = () => { }, handleErr = () => { }) {
  return (dispatch) => {
    let params = Object.assign({}, p, {
      subscribe: null,
      msgTypes: [ACTION_TYPE.DETAIL_PRICE_INFO],
    });
    return openConnection(ENDPOINT_REQUEST.wsSTOCK.SNAPSHOT, params, callback, handleErr);
  };
}

function getAggregateOrderBookAction(p, callback = () => { }, handleErr = () => { }) {
  const params = Object.assign({}, p, {
    subscribe: true,
    msgTypes: [ACTION_TYPE.AGGREGATE_ORDER_BOOK],
  });
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.STREAMING, params, callback, handleErr);
}

function getBestBidBestAskAction(p, callback = () => { }, handleErr = () => { }) {
  const params = Object.assign({}, p, {
    subscribe: true,
    msgTypes: [ACTION_TYPE.BEST_BID_ASK],
  });
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.STREAMING, params, callback, handleErr);
}

function getClosingPriceAction(p, callback = () => { }, handleErr = () => { }) {
  const params = Object.assign({}, p, {
    subscribe: true,
    msgTypes: [ACTION_TYPE.CLOSING_PRICE],
  });
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.STREAMING, params, callback, handleErr);
}

function getStatisticsAction(p, callback = () => { }, handleErr = () => { }) {
  const params = Object.assign({}, p, {
    subscribe: true,
    msgTypes: [ACTION_TYPE.STATISTICS],
  });
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.STREAMING, params, callback, handleErr);
}

function getCompanyInfoAction(p, callback = () => { }) {
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.OTHERS, p, callback);
}

function getWSStockAction(p, callback = () => { }) {
  return openConnection(LOGIN_ITEM ? ENDPOINT_REQUEST.wsSTOCK.SNAPSHOT : ENDPOINT_REQUEST.wsSTOCK.OTHERS, p, callback);
}

function getShareChangeAction(p, callback = () => { }) {
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.OTHERS, p, callback);
}

function getTradeDistributionAction(p, callback = () => { }) {
  return (dispatch, getState) => {
    const { mdsToken } = getState().trade
    let params = Object.assign({}, p, {
      sessID: mdsToken,
      msgTypes: [ACTION_TYPE.TRADE_DISTRIBUTION]
    })
    return openConnection(ENDPOINT_REQUEST.wsSTOCK.SNAPSHOT, params, callback);
  }
}

function getDividendRecordAction(p, callback = () => { }) {
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.OTHERS, p, callback);
}

function setMarketStockAction(p, callback = () => { }) {
  return async (dispatch) => {
    await dispatch({
      type: I_TRADE_ACTION.SET_MARKET_STOCK,
      stockCode: p.stockCode,
      marketID: p.marketID,
    });
    callback();
  };
}

function setNoChangeMarketStockAction(p, callback = () => { }) {
  return async (dispatch) => {
    await dispatch({
      type: I_TRADE_ACTION.SET_NO_CHANGE_MARKET_STOCK,
      NCstockCode: p.NCstockCode,
      NCmarketID: p.NCmarketID,
    });
    callback();
  };
}

function setPlaceOrderParamsAction(p) {
  return (dispatch) => {
    dispatch({
      type: I_TRADE_ACTION.SET_PLACE_ORDER_PARAMS,
      ...p,
    });
  };
}

function loginMDSAction(p) {
  return (dispatch) => {
    // const id = "trial_qw01";
    const id = p
    const companyEntity = appConfigConstants.MDSEntityKey;
    const companySuperkey = appConfigConstants.MDSSuperkey;
    const date = moment().utc().format("YYYYMMDDHHmmssSSS");
    const templateStr = [companyEntity, date, id].join(":");
    const super_key = CryptoJS.enc.Utf8.parse(companySuperkey);
    const dataDecrypted = CryptoJS.AES.encrypt(templateStr, super_key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    const params = {
      msgType: 'LOGIN',
      id: id,
      data: {
        entity: companyEntity,
        token: dataDecrypted.ciphertext.toString(CryptoJS.enc.Hex)
      }
    }
    // const diffData = {
    // 	device: "Web",
    // 	Agreement:  "N",
    // 	password: "SCB",
    // 	language,
    // 	entity: companyEntity,
    // 	token: dataDecrypted.ciphertext.toString(CryptoJS.enc.Hex),
    // };
    // const language = utilsFunction.switchToolTipsLanguage(store.getState().app.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC);
    // const params = {
    //   msgType: "LOGIN",
    //   id: id,
    //   data: diffData,
    // };

    getWSStockAction(params, (res) => {
      if (res.rtnCode === 0) {
        dispatch({
          type: I_TRADE_ACTION.SET_MDS_TOKEN,
          mdsToken: res.detail.data,
        });
        dispatch({
          type: I_TRADE_ACTION.SET_QUOTE_ACCOUNT,
          mdsAccountType: res.service,
        });
      }
    });
  };
}

function logoutMDSAction() {
  return (dispatch, getState) => {
    const params = {
      msgType: ACTION_TYPE.LOGOUT,
      sessID: getState().trade.mdsToken
    }
    openConnection(LOGIN_ITEM ? ENDPOINT_REQUEST.wsSTOCK.SNAPSHOT : ENDPOINT_REQUEST.wsSTOCK.OTHERS, params, () => { });
  }
}

function getHistoricalData(p, callback = () => { }) {
  return openConnection.call(null, ENDPOINT_REQUEST.wsSTOCK.SNAPSHOT, p, callback);
}

function getTopRankAction(p, callback = () => { }, handleErr = () => { }) {
  let params = Object.assign({}, p, {
    subscribe: null,
    msgTypes: [ACTION_TYPE.TOP_RANK]
  })
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.SNAPSHOT, params, callback, handleErr);
}

function getDetailIndustryRankAction(p, callback = () => { }, handleErr = () => { }) {
  let params = Object.assign({}, p, {
    subscribe: null,
    msgTypes: [ACTION_TYPE.DETAIL_INDUSTRY_RANK]
  })
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.OTHERS, params, callback, handleErr);
}

function getFinancialsDataAction(p, callback = () => { }, handleErr = () => { }) {
  let params = Object.assign({}, p, {
    subscribe: null,
    msgType: ACTION_TYPE.SECURITY_FINANCIAL_REPORT
  })
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.OTHERS, params, callback, handleErr);
}

function getwarrantsAction(p, callback = () => { }, handleErr = () => { }) {
  let params = Object.assign({}, p, {
    subscribe: null,
    msgType: ACTION_TYPE.WARRANT_BULLBEAR
  })
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.OTHERS, params, callback, handleErr);
}

function getIndexDataAction(p, callback = () => { }) {
  const { mdsToken } = store.getState().trade;
  const params = Object.assign({}, p, {
    msgTypes: [ACTION_TYPE.INDEX_DATA],
    sessID: mdsToken,
  });
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.SNAPSHOT, params, callback);
}

function getOptionsAction(p, callback = () => { }) {
  const params = {
    subscribe: true,
    msgTypes: [ACTION_TYPE.IMPLIED_VOLATILITY],
    symbols: [{ exchangeID: Converter.mappingWebSocketMarket(p.exchangeID), key: p.key }],
  };
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.MDS9997, params, callback);
}

function getSeriesProductAction(p, callback) {
  userServices.getseriesProductEnquiry(p, (res) => {
    callback(res);
  });
}

function getTradeTickerAction(p, callback = () => { }, handleErr = () => { }) {
  const params = { ...p, subscribe: true, msgTypes: [ACTION_TYPE.TRADE_TICKER] };
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.STREAMING, params, callback, handleErr);
}

function getBrokerQueueAction(p, callback = () => { }, handleErr = () => { }) {
  const params = { ...p, subscribe: true, msgTypes: [ACTION_TYPE.BROKER_QUEUE] };
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.STREAMING, params, callback, handleErr);
}

function getTradeLogAction(p, callback = () => { }, handleErr = () => { }) {
  const params = {
    ...p,
    // subscribe: true,
    msgType: ACTION_TYPE.TRADE_LOG,
  };
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.STREAMING, params, callback, handleErr);
}

function getSecurityDefintionAction(p, callback = () => { }, handleErr = () => { }) {
  const params = { ...p, subscribe: true, msgTypes: [ACTION_TYPE.SECURITY_DEFINITION] };
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.STREAMING, params, callback, handleErr);
}

function getGreyAggregateOrderBookAction(p, callback = () => { }, handleErr = () => { }) {
  const params = Object.assign({}, p, {
    subscribe: true,
    msgTypes: [ACTION_TYPE.GREY_AGGREGATE_ORDER_BOOK],
  });
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.PROXY, params, callback, handleErr);
}

function getGreyBrokerQueueAction(p, callback = () => { }, handleErr = () => { }) {
  const params = {
    ...p,
    subscribe: true,
    msgTypes: [ACTION_TYPE.GREY_BROKER_QUEUE],
  };
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.PROXY, params, callback, handleErr);
}

function getGreyTradeLogAction(p, callback = () => { }, handleErr = () => { }) {
  const params = {
    ...p,
    // subscribe: true,
    msgType: ACTION_TYPE.GREY_TRADE_LOG,
  };
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.PROXY, params, callback, handleErr);
}

function getGreyTradeTickerAction(p, callback = () => { }, handleErr = () => { }) {
  const params = {
    ...p,
    subscribe: true,
    msgTypes: [ACTION_TYPE.GREY_TRADE_TICKER],
  };
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.PROXY, params, callback, handleErr);
}

function getGreySecurityDefintionAction(p, callback = () => { }, handleErr = () => { }) {
  const params = { ...p, subscribe: true, msgTypes: [ACTION_TYPE.GREY_SECURITY_DEFINITION] };
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.PROXY, params, callback, handleErr);
}

function getGreyStatisticsAction(p, callback = () => { }, handleErr = () => { }) {
  const params = Object.assign({}, p, {
    subscribe: true,
    msgTypes: [ACTION_TYPE.GREY_STATISTICS],
  });
  return openConnection(ENDPOINT_REQUEST.wsSTOCK.PROXY, params, callback, handleErr);
}
